var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Blog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blog-2",
    "data-name": "Blog",
    transform: "translate(2.434 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M29.381,90.66a2.7,2.7,0,0,1-.938,1.58v7.223a.647.647,0,0,1-.2.467.674.674,0,0,1-.475.193H16a.675.675,0,0,1-.475-.193.646.646,0,0,1-.2-.467V87.92a.647.647,0,0,1,.2-.467A.675.675,0,0,1,16,87.26H22.25a15.754,15.754,0,0,1,1.763-1.967l.009-.011H16a2.714,2.714,0,0,0-1.9.772,2.61,2.61,0,0,0-.788,1.866V99.464a2.607,2.607,0,0,0,.788,1.866,2.717,2.717,0,0,0,1.9.772H27.77a2.717,2.717,0,0,0,1.9-.772,2.612,2.612,0,0,0,.788-1.866V89.941a.084.084,0,0,0-.013-.012A6.144,6.144,0,0,1,29.381,90.66Z",
    transform: "translate(-13.308 -81.92)",
    fill: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M144.071,0s-.618.924-4.657,2.29c-4.119,1.394-6.654,7.064-6.654,7.064-.61,1.162-3.023,5.988-3.023,5.988-.665,1.247.553,1.983,1.268.7,1.369-2.471,2.253-4.729,4.335-4.793,3.037-.094,5.114-2.746,4.46-2.622-.86.374-2.756.028-1.639-.144,2.68-.215,4.332-2.23,3.794-2.366a2.578,2.578,0,0,1-2.01-.086C144.676,5.451,144.071,0,144.071,0Z",
    transform: "translate(-124.964 0)",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.35d56ce1b10f3c1d0ac4d3a2b86a86ce.svg";
export { ForwardRef as ReactComponent };